import { BACKEND } from "./api";

export const SITE_URL = "https://www.wandervibejourneys.in";
export const EMAIL = "info@wandervibejourneys.in";
export const PHONE = "+91 8755211549";
export const PHONE_TEL = "+918755211549";
export const WA_NUMBER = "918755211549";
export const DEFAULT_WA_MSG = "Hi Wandervibe Journeys, I am interested in planning a trip. Please share the details.";

export const waLink = (msg = DEFAULT_WA_MSG) => `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;
export const tourWaMsg = (title) => `Hi Wandervibe Journeys, I am interested in the ${title}. Please share the details.`;

export const imgUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u);
export const priceLabel = (t) => (t.price ? `₹${Number(t.price).toLocaleString("en-IN")}` : t.price_note || "Price on request");
export const durationLabel = (t) =>
  t.duration_days ? `${t.duration_days} Days${t.duration_nights != null ? ` / ${t.duration_nights} Nights` : ""}` : "Duration on request";
export const tourPath = (t) => `/${t.type === "family" ? "family-tours" : "group-tours"}/${t.slug}`;

export const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export const TRAVEL_CATEGORIES = ["Group Tour", "Family Tour", "Spiritual Journey", "Custom Trip"];
export const FAMILY_DESTINATIONS = [
  { name: "Uttarakhand", image: "/images/lake.jpg" },
  { name: "Himachal Pradesh", image: "/images/himachal.jpg" },
  { name: "Kashmir", image: "/images/kashmir.jpg" },
  { name: "Ladakh", image: "/images/ladakh2.jpg" },
  { name: "Spiti Valley", image: "/images/spiti.jpg" },
  { name: "Rajasthan", image: "/images/rajasthan.jpg" },
];
